define('services/VariantProductService',[
    'app',
    'modules/module',
    'services/EntityCrudService',
    'services/LocalStorageService',
    'services/NotificationService'
], function (app, module) {
    'use strict';
    return module.factory('VariantProductService', [
        '$injector',
        'LocalStorageService',
        'NotificationService',
        '$q',
        VariantProductService
    ]);
});


function VariantProductService($injector, LocalStorageService, NotificationService, $q) {

    crudInstance = $injector.instantiate(CrudService);
    crudInstance.setType('VariantProduct');

    angular.extend(this, crudInstance);

    this.findByIdsIn = function (ids) {
        var ref = $q.defer();
        $injector.get("ModelFactory").VariantProduct().findByIdsIn({ids: ids}).$promise.then(function (response) {
            ref.resolve(response);
        }, NotificationService.notifyRequestError);
        return ref.promise;
    };

    return this;
};
